import { IValidationRule } from "@/types"

const articleValidationRules: { [s: string]: IValidationRule } = {
    manufacturerDescription: {
        required: true
    },
    manufacturerArticleNo: {
        required: true
    },
    articleClass: {
        required: true,
    },
    description: {
        required: true
    },
    dimension: {
        type: "decimal",
        min: 0
    },
    volume: {
        type: "decimal",
        min: 0
    },
    weight: {
        type: "decimal",
        min: 0
    },
    wheelsWidth: {
        type: "decimal",
        min: 0
    },
    wheelsHeight: {
        type: "decimal",
        min: 0
    },
    radius: {
        type: "decimal",
        min: 0
    },
    sequence: {
        type: "integer",
        min: 0
    },
    productLine: {
        required: true
    },
    productFamily: {
        required: true
    },
    productModelExt: {
        required: true
    },
}

export default articleValidationRules
